import { Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function TermsOfServicePage() {
  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "32px 24px" }}>
      <Typography>
        <Title level={1}>Terms of Service</Title>
        <Paragraph type="secondary">Last updated: April 23, 2026</Paragraph>

        <Paragraph>
          Welcome to <Text strong>Spotlight</Text> by Bits2b s.r.o. ("App"). By accessing or using
          our App, you agree to be bound by these Terms of Service ("Terms").
        </Paragraph>

        <Title level={2}>1. Use of the App</Title>
        <Paragraph>
          Our App provides integration with the WhatsApp Business API. You agree to use the App only
          for lawful purposes and in compliance with these Terms, as well as the{" "}
          <a
            href="https://www.whatsapp.com/legal/business-terms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp Business Terms of Service
          </a>
          .
        </Paragraph>

        <Title level={2}>2. User Responsibilities</Title>
        <Paragraph>You are responsible for:</Paragraph>
        <ul>
          <li>Maintaining the confidentiality of your account credentials.</li>
          <li>
            Obtaining necessary consents from your contacts before sending them messages via our App.
          </li>
          <li>
            Ensuring that your messages comply with WhatsApp's Commerce and Business Policies.
          </li>
          <li>Not sending spam, offensive, or illegal content.</li>
        </ul>

        <Title level={2}>3. Meta and WhatsApp Policies</Title>
        <Paragraph>
          By using our App, you acknowledge that the messaging functionality relies on the WhatsApp
          Business API provided by Meta Platforms, Inc. You must strictly adhere to all Meta and
          WhatsApp policies. We reserve the right to suspend or terminate your access if you violate
          these policies.
        </Paragraph>

        <Title level={2}>4. Intellectual Property</Title>
        <Paragraph>
          The App and its original content, features, and functionality are owned by{" "}
          <Text strong>Bits2b s.r.o.</Text> and are protected by international copyright, trademark,
          and other intellectual property laws.
        </Paragraph>

        <Title level={2}>5. Limitation of Liability</Title>
        <Paragraph>
          To the maximum extent permitted by law, <Text strong>Bits2b s.r.o.</Text> shall not be
          liable for any indirect, incidental, special, consequential, or punitive damages, or any
          loss of profits or revenues, whether incurred directly or indirectly, or any loss of data,
          use, goodwill, or other intangible losses, resulting from your use of the App or the
          WhatsApp Business API.
        </Paragraph>

        <Title level={2}>6. Termination</Title>
        <Paragraph>
          We may terminate or suspend your access to our App immediately, without prior notice or
          liability, for any reason whatsoever, including without limitation if you breach the Terms.
        </Paragraph>

        <Title level={2}>7. Changes to Terms</Title>
        <Paragraph>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
          By continuing to access or use our App after those revisions become effective, you agree to
          be bound by the revised terms.
        </Paragraph>

        <Title level={2}>8. Contact Us</Title>
        <Paragraph>
          If you have any questions about these Terms, please contact us at:
        </Paragraph>
        <Paragraph>
          <Text strong>Email:</Text> saas@bits2b.com
          <br />
          <Text strong>Website:</Text>{" "}
          <a href="https://bits2b.com" target="_blank" rel="noopener noreferrer">
            bits2b.com
          </a>
        </Paragraph>
      </Typography>
    </div>
  );
}
